<template>
  <!-- 結果送付先出力 -->
  <div id="HSTAgentLabelPrint">
    <div id="container">
      <div class="labelTitle lable">結果送付先出力</div>
      <!--検索条件 -->
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th>受付番号</th>
            <td><input type="text" v-model="searchCondition.receiptNumber"/></td>
            <th>機種</th>
            <td>
              <select v-model="searchCondition.instrumentKind">
                <option v-for="model in modelList" :value="model.value" :key="model.value">
                  {{ model.label1 }}
                </option>
              </select>
            </td>
            <th>医療機関</th>
            <td><input type="text" v-model="searchCondition.hospital"/></td>
            <th>患者名</th>
            <td><input type="text" v-model="searchCondition.patientName"/></td>
          </tr>
          <tr>
            <th>申込日</th>
            <td colspan="3"><input type="date" v-model="searchCondition.applicationDateStart"/> ～ <input type="date" v-model="searchCondition.applicationDateEnd"/></td>
            <th>検査日</th>
            <td colspan="3"><input type="date" v-model="searchCondition.inspectionDateStart"/> ～ <input type="date" v-model="searchCondition.inspectionDateEnd"/></td>
          </tr>
          <tr>
            <th>解析完了日</th>
            <td colspan="3"><input type="date" v-model="searchCondition.analyisisDateStart"/> ～ <input type="date" v-model="searchCondition.analyisisDateEnd"/></td>
            <th>ブロック</th>
            <td>
              <select v-model="searchCondition.block">
                <option value=""></option>
                <option v-for="item in blockMaster" :key="item.code" :value="item.code">{{item.name}}</option>
              </select>
            </td>
            <th>担当支店</th>
            <td>
              <select v-model="searchCondition.branchOfficeCode">
                <option value=""></option>
                <option v-for="item in branchOfficeMaster" :key="item.code" :value="item.code">{{item.name}}</option>
              </select>
           </td>
          </tr>
          <tr>
            <th>コピー</th>
            <td>
              <select v-model="searchCondition.copy">
                <option value=""></option>
                <option value="0">未</option>
                <option value="1">済</option>
              </select>
            </td>
            <th>一括DL</th>
            <td>
              <select v-model="searchCondition.dl">
                <option value=""></option>
                <option value="0">未</option>
                <option value="1">済</option>
              </select>
            </td>
            <th>状態</th>
            <td>
              <select v-model="searchCondition.status">
                <option v-for="model in statusList" :value="model.value" :key="model.value">
                  {{ model.label1 }}
                </option>
              </select>
            </td>
            <th>巻き取り対象</th>
            <td>
              <select v-model="searchCondition.takeupStatus">
                <option v-for="model in takeupStatusList" :value="model.value" :key="model.value">
                  {{ model.label1 }}
                </option>
              </select>
            </td>
          </tr>
        </table>
        <div class="searchButton-area">
          <b-button class="is-primary" @click="doSearch">検索</b-button>
          <b-button class="backButton is-primary" @click="back">戻る</b-button>
        </div>
      </div>
      <!-- 検索結果 -->
      <div class="result-area" v-if="data.length > 0">
        <div class="operation-area">
            <b-button class="operationButton is-primary" :disabled="!selectedRows.length" @click="bulkDownload()">報告書一括ダウンロード</b-button>
            <b-button class="operationButton is-primary" :disabled="!selectedRows.length" @click="clipboardCopy('clipbordTable')">クリップボードにコピー</b-button>
            <b-button class="operationButton is-primary" :disabled="!canChangeStatus" @click="changeStatus">結果送付済み(完了)にする</b-button>
        </div>
        <span class="result-count" style="position: relative; top:16px;">件数：{{data.length}}件</span>
        <b-table
            id="hstAgentLabelTable"
            :data="data"
            :paginated="true"
            checkable
            :checked-rows.sync="selectedRows"
            per-page="100"
            pagination-position="both"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
            default-sort="receiptNumber">
            <template slot-scope="props">
              <b-table-column field="receiptNumber" label="受付番号" width="130" centered sortable>
                {{props.row.receiptNumber}}
              </b-table-column>
              <b-table-column field="instrumentKind" label="機種" width="180" sortable>
                {{props.row.instrumentKind}}
              </b-table-column>
              <b-table-column field="hospital" label="医療機関" width="220" sortable>
                {{props.row.hospital}}
              </b-table-column>
              <b-table-column field="patientName" label="患者名" width="150" sortable>
                {{props.row.patientName}}
              </b-table-column>
              <b-table-column field="address" label="結果送付先" width="270" sortable>
                {{props.row.address}} {{props.row.address2}}
              </b-table-column>
              <b-table-column field="status" label="状態" width="90" centered sortable>
                  <span :class="getTagClass4HSTAgentLabelPrint(props.row.status)">
                    {{props.row.status}}
                  </span>
              </b-table-column>
              <b-table-column field="takeupStatus" label="巻き取り対象" width="90" centered sortable>
                  <span :class="getTagClassTakeupStatus(props.row.takeupStatus)">
                    {{props.row.takeupStatus}}
                  </span>
              </b-table-column>
              <b-table-column field="applicationDate" label="申込日" width=100 centered sortable>
                {{props.row.applicationDate }}
              </b-table-column>
              <b-table-column field="inspectionDate" label="検査日" width="100" centered sortable>
                {{props.row.inspectionDate }}
              </b-table-column>
              <b-table-column field="analysysDate" label="解析完了日" width="100" centered sortable>
                {{props.row.analysysDate }}
              </b-table-column>
              <b-table-column field="doneDL" label="DL" width="75" centered sortable>
                <b-icon v-if="props.row.doneDL" icon="check-bold" />
              </b-table-column>
              <b-table-column field="doneCopy" label="コピー" width="75" centered sortable>
                <b-icon v-if="props.row.doneCopy" icon="check-bold" />
              </b-table-column>
            </template>
        </b-table>
      </div>
      <div class="result-area" v-if="dataBlank && data.length == 0">
        <div class="result-count">件数：{{data.length}}件</div>
      </div>
      <div class="forClipboadCopy">
        <b-table
            id="clipbordTable"
            :data="copyTableData">
            <template slot-scope="props">
              <b-table-column field="zip" label="zip">
                {{props.row.zip}}
              </b-table-column>
              <b-table-column field="address" label="住所">
                {{props.row.address}}
              </b-table-column>
              <b-table-column field="address" label="建物名">
                {{props.row.address2}}
              </b-table-column>
              <b-table-column field="organization" label="会社名">
                {{props.row.organization}}
              </b-table-column>
              <b-table-column field="secction" label="部門名">
                {{props.row.secction}}
              </b-table-column>
              <b-table-column field="shipTo" label="宛名">
                {{props.row.shipTo}}
              </b-table-column>
              <b-table-column field="count" label="件数">
                {{props.row.count}}
              </b-table-column>
              <b-table-column field="patients" label="患者リスト">
                {{props.row.patients}}
              </b-table-column>
            </template>
        </b-table>
      </div>
    </div>
  </div>
</template>
<script>
import {choicesType} from "@/components/mock/base/const.js";
import {requestStatus} from "@/components/mock/base/const.js";
import {takeupStatus} from "@/components/mock/base/const.js";
export default {
  name: "HSTAgentLabelPrint",
  methods: {
    back: function(){
      this.$router.go(-1);
    },
    doSearch: function() {
      var isSearchParam = false
      var keys = Object.keys(this.searchCondition)
      for(var i=0; i < keys.length; i++){
        if(this.searchCondition[keys[i]]){
          isSearchParam = true
          break;
        }
      }
      if(!isSearchParam){
        // 検索条件が１つも設定されていない場合
        this.showErrorMessage("検索条件が入力されていません。")
        return;
      }
      this.selectedRows = []
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.internalAgentOffer.getDestinationOutputListPOST({
            body: _this.searchCondition
          });
        },
        function(result){
          _this.data = result.obj
          _this.dataBlank = true;
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    bulkDownload: function(){
      var _this = this;
      var receiptNo = this.getSelectedReciptNo();
      this.downloadApiCall(function(client){
          return client.apis.internalAgentOffer.downloadInspectionReportPOST({
            body: receiptNo
          })
        },
        function(message) {
          if(message == "Failed to fetch"){
            message = "タイムアウトが発生しました。<br>ダウンロード件数を減らして再実行してください。"
          }
          _this.showErrorMessage(message);
        },
        function() {
          for(var rowItem of _this.selectedRows) {
            rowItem.doneDL = true
          }          
        }
      );
    },
    clipboardCopy: function(elementId) {
      var receiptNo = this.getSelectedReciptNo();

      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.internalAgentOffer.setCopyFlagPOST({
            body:receiptNo
          });
        },
        function(result){
          for(var rowItem of _this.selectedRows) {
            rowItem.doneCopy = true
          }
          _this.copyExec(elementId);
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    copyExec: function(elementId) {
      this.copyTableData = [];
      //selectedRowsは選択順に格納されているので、copyTableDataを表示順に格納し直す。
      for(var rowItem of this.data){
        if(this.selectedRows.indexOf(rowItem) >= 0){
          var strkey = rowItem.zip + rowItem.address1 + rowItem.address2 + rowItem.organization + rowItem.secction + rowItem.shipTo;
          strkey = this.format(strkey);
          var copyItem = this.copyTableData.filter(function(item) { return item.key == strkey; });
          if(copyItem.length != 0){
            copyItem[0].count += 1
            copyItem[0].patients = copyItem[0].patients + "," + rowItem.patientName
          } else {
            copyItem = {
              key: strkey,
              zip: rowItem.zip,
              address: rowItem.address,
              address2: rowItem.address2,
              organization: rowItem.organization,
              secction: rowItem.secction,
              shipTo: rowItem.shipTo,
              count : 1,
              patients: rowItem.patientName
            }
            this.copyTableData.push(copyItem)
          }
        }
      }
      this.$nextTick(() => {
        //DOMが更新された後に呼ばれるコールバック
        var btable = document.getElementById(elementId);
        var tableWrapper = btable.getElementsByClassName("table-wrapper")[0];
        var table = tableWrapper.getElementsByTagName("table")[0];
        var tbody = table.getElementsByTagName("tbody")[0];
        navigator.clipboard
        .writeText(tbody.innerText)
        .then(() => {
          this.showMessage("クリップボードにコピーしました。");
        })
        .catch(err => {
          this.showMessage("コピーに失敗しました");
          console.log(err);
        });
      })
    },
    getSelectedReciptNo: function() {
      var result = []
      for(var rowItem of this.selectedRows) {
        result.push(rowItem.receiptNumber)
      }
      return result
    },
    getSelectedUpdateTargetReciptNo: function() {
      var result = []
      for(var rowItem of this.selectedRows) {
        if (rowItem.status == '結果送付待ち') {
          result.push(rowItem.receiptNumber)
        }
      }
      return result
    },
    changeStatus: function(){
      var receiptNo = this.getSelectedUpdateTargetReciptNo();

      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.internalAgentOffer.setResultSendPOST({
            body:receiptNo
          });
        },
        function(result){
          for(var rowItem of _this.selectedRows) {
            if (rowItem.status == '結果送付待ち') {
              rowItem.status = '完了'
            }
          }
          _this.showSuccess(result, function(){})
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    format: function(str) {
      //空白除去
      str = str.replace(/　/g, "").replace(/ /g, "");
      //大文字⇒小文字
      str = str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      });
      //全角カナ⇒半角カナ
      var kanaMap = {
          "ガ": "ｶﾞ", "ギ": "ｷﾞ", "グ": "ｸﾞ", "ゲ": "ｹﾞ", "ゴ": "ｺﾞ",
          "ザ": "ｻﾞ", "ジ": "ｼﾞ", "ズ": "ｽﾞ", "ゼ": "ｾﾞ", "ゾ": "ｿﾞ",
          "ダ": "ﾀﾞ", "ヂ": "ﾁﾞ", "ヅ": "ﾂﾞ", "デ": "ﾃﾞ", "ド": "ﾄﾞ",
          "バ": "ﾊﾞ", "ビ": "ﾋﾞ", "ブ": "ﾌﾞ", "ベ": "ﾍﾞ", "ボ": "ﾎﾞ",
          "パ": "ﾊﾟ", "ピ": "ﾋﾟ", "プ": "ﾌﾟ", "ペ": "ﾍﾟ", "ポ": "ﾎﾟ",
          "ヴ": "ｳﾞ", "ヷ": "ﾜﾞ", "ヺ": "ｦﾞ",
          "ア": "ｱ", "イ": "ｲ", "ウ": "ｳ", "エ": "ｴ", "オ": "ｵ",
          "カ": "ｶ", "キ": "ｷ", "ク": "ｸ", "ケ": "ｹ", "コ": "ｺ",
          "サ": "ｻ", "シ": "ｼ", "ス": "ｽ", "セ": "ｾ", "ソ": "ｿ",
          "タ": "ﾀ", "チ": "ﾁ", "ツ": "ﾂ", "テ": "ﾃ", "ト": "ﾄ",
          "ナ": "ﾅ", "ニ": "ﾆ", "ヌ": "ﾇ", "ネ": "ﾈ", "ノ": "ﾉ",
          "ハ": "ﾊ", "ヒ": "ﾋ", "フ": "ﾌ", "ヘ": "ﾍ", "ホ": "ﾎ",
          "マ": "ﾏ", "ミ": "ﾐ", "ム": "ﾑ", "メ": "ﾒ", "モ": "ﾓ",
          "ヤ": "ﾔ", "ユ": "ﾕ", "ヨ": "ﾖ",
          "ラ": "ﾗ", "リ": "ﾘ", "ル": "ﾙ", "レ": "ﾚ", "ロ": "ﾛ",
          "ワ": "ﾜ", "ヲ": "ｦ", "ン": "ﾝ",
          "ァ": "ｧ", "ィ": "ｨ", "ゥ": "ｩ", "ェ": "ｪ", "ォ": "ｫ",
          "ッ": "ｯ", "ャ": "ｬ", "ュ": "ｭ", "ョ": "ｮ",
          "。": "｡", "、": "､", "ー": "-", "「": "｢", "」": "｣", "・": "･",
          "―": "-","－": "-","—": "-", "ｰ": "-",
      }
      var reg = new RegExp('(' + Object.keys(kanaMap).join('|') + ')', 'g');
      str =  str.replace(reg, function (match) {
                        return kanaMap[match];
                        }).replace(/゛/g, 'ﾞ').replace(/゜/g, 'ﾟ');
      return str;
    }
  },
  data() {
    var statusList = [
      {
        value: ""
      },
      {
        value: requestStatus.resultSendReady+"",
        label1: "結果送付待ち"
      },
      {
        value: requestStatus.completion+"",
        label1: "完了"
      },
      {
        value: requestStatus.completionAppropriation+"",
        label1: "完了（計上済）"
      },
    ]
    var takeupStatusList = [
      {
        value:""
      },
      {
        value:takeupStatus.nonTarget+"",
        label1:"対象無し"
      },
      {
        value:takeupStatus.mainOffice+"",
        label1:"本社"
      },
      {
        value:takeupStatus.branch+"",
        label1:"支店"
      }
    ]
    var modelList =  this.getChoiceList(choicesType.hstKind, false);
    var modelList2 =  this.getChoiceList(choicesType.holterKindSp, false);
    modelList = modelList.concat(modelList2)

    modelList.unshift({value: ""})
    let branchOfficeMaster = this.getBranchOfficeMaster();
    let blockMaster = this.getBlockMaster();
    return {
      data : [],
      selectedRows:[],
      searchCondition: {
        receiptNumber: "",
        instrumentKind: "",
        status: "",
        hospital: "",
        patientName: "",
        applicationDateStart: "",
        applicationDateEnd: "",
        inspectionDateStart: "",
        inspectionDateEnd: "",
        analyisisDateStart: "",
        analyisisDateEnd: "",
        block:"",
        branchOfficeCode: "",
        copy: "",
        dl: "",
        takeupStatus: "",
        dataBlank: false
      },
      fileListStr:"",
      copyTableData:[],
      modelList: modelList,
      statusList: statusList,
      branchOfficeMaster: branchOfficeMaster,
      blockMaster :blockMaster,
      takeupStatusList: takeupStatusList,
    };
  },
  computed:{
    canChangeStatus: function(){
      var ret = false;
      for(var rowItem of this.selectedRows) {
        if(rowItem.doneDL){
          ret = true;
        } else {
          ret = false;
          break;
        }
      }
      return ret;
    }
  },
  filters: {},
  components: {},
};
</script>
<style lang="scss" scoped>
input {
  width: 200px;
}
.forClipboadCopy {
  display: block;
  position:absolute;
  top: -99999px;
  left: -99999px;
}
.tag {
  width :90px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/offer/HSTAgentLabelPrint.vue